export default __webpack_public_path__ + "static/media/product2.4be33d81.png";